export default "__VITE_ASSET__BMom$0hW__"